/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Solver_TagInputs */

const en_cp_solver_tag = /** @type {(inputs: Cp_Solver_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solve a real problem`)
};

const id_cp_solver_tag = /** @type {(inputs: Cp_Solver_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pecahkan masalah nyata`)
};

/**
* | output |
* | --- |
* | "Solve a real problem" |
*
* @param {Cp_Solver_TagInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_solver_tag = /** @type {((inputs?: Cp_Solver_TagInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Solver_TagInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_solver_tag(inputs)
	return en_cp_solver_tag(inputs)
});